module.exports = __webpack_public_path__ + "1.4.15-unryo/img/deploy.086273fc.jpg";